module.exports = __webpack_public_path__ + "static/media/slash.1f41acbe.svg";